export default "__VITE_ASSET__DreoPo7X__"